<form class="w-100 h-100 form" [formGroup]="footerLogoForm" (ngSubmit)="sendData()" *ngIf="footerLogoData">
  <h4 class="text-center">Editar Logo de footer (fondo para íconos blancos)</h4>
  <div class="row mx-0 my-3 p-0 w-100">
    <div class="col-12 pl-xl-0 mt-2 mb-4">
      <div class="vs-outline-editCard btn-custom-banner bg-footer">
        <img class="given-img menu-img" [src]="srcData | safeDom" alt="img-footer-logo" *ngIf="fileImg64">
        <div class="btn-custom-file w-100">
          <label for="file-upload-footer-logo" class="custom-file-upload h-fit-content p-3">
            <mat-icon>{{!fileImg64 ? 'image' : '' }} </mat-icon>
            <span class="my-2" *ngIf="!wrongSize">
              Elegir imagen de 200px x 200px
            </span>
            <span class="my-2 text-danger" *ngIf="wrongSize">{{wrongSize}}</span>
          </label>
          <input id="file-upload-footer-logo" type="file" accept="image/*" (change)="getBase64($event)"/>
        </div>
      </div>
    </div>
  </div>
  <div class="bottom-button">
    <button class="vs-btn-blue" type="submit" [disabled]="footerLogoForm.invalid">
      Guardar
    </button>
  </div>
</form>
